module.exports = __webpack_public_path__ + "static/media/polygon-color.5ea6ab8f.svg";